import {
    createMountsMullionsHorizontalConfig,
    createMountsFunctionalMullionsConfig,
    createMountsMullionsVerticalConfig,
    createMountsToptrackSlidingDoorConfig,
} from "../../base";
import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createSlidingDoorMountsToptrackSlidingDoorConfig = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    partition: Partition,
): IComponentConfig => {
    const toptrackStuctureCode = MountsService.getTopTrack(partition);

    return createMountsToptrackSlidingDoorConfig()
        .structureType(toptrackStuctureCode)
        .qty(1)
        .area(1)
        .build();
};

const createSlidingDoorMountsKompasHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);

    const horizontalLinesQty = 1;
    const sides = 2;

    const qty = Math.round(width * horizontalLinesQty * sides) || 0;

    return createMountsMullionsHorizontalConfig()
        .qty(horizontalLinesQty)
        .width(width)
        .area(qty)
        .build();
};

const createSlidingDoorMountsKompasVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const height = MountsService.getDoorTotalHeight(partition);

    const verticalLinesQty = 1;
    const sides = 2;

    const qty = Math.round(height * verticalLinesQty * sides) || 0;

    return createMountsMullionsVerticalConfig()
        .qty(verticalLinesQty)
        .width(height)
        .area(qty)
        .build();
};

const createSlidingDoorMountsFunctionalMullionsConfig = (
    partition: Partition,
): IComponentConfig => {
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const qty = MountsService.getFunctionalMullionLength(partition);

    return createMountsFunctionalMullionsConfig()
        .qty(2)
        .width(doorWidth)
        .area(qty)
        .build();
};

export const KompasCGFDoorsConfigs = (partition: Partition) => [
    createSlidingDoorMountsToptrackSlidingDoorConfig(partition),
    createSlidingDoorMountsKompasHorizontalConfig(partition),
    createSlidingDoorMountsKompasVerticalConfig(partition),
    createSlidingDoorMountsFunctionalMullionsConfig(partition),
];
